import { postRequest } from '@/core';
import { subOrders } from '@/requests';

export default async function sendToConfirmRequest(orderId, driver) {
	let url = subOrders.getSendToConfirmPath(orderId);
	try {
		let response = await postRequest(url, {}, driver);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}
